import React, { Component } from 'react';

class PaymentTypes extends Component {
  render() {
    return(
      <div>
        <button type="button" onClick={event => this.props.handlePaymentTypeChange('CASH')} className={'btn btn-lg ' + (this.props.paymentType === 'CASH' ? 'btn-success mt-1' : 'btn-primary mt-1')}>CASH</button>
        &nbsp;
        <button type="button" onClick={event => this.props.handlePaymentTypeChange('DEBIT')} className={'btn btn-lg ' + (this.props.paymentType === 'DEBIT' ? 'btn-success mt-1' : 'btn-primary mt-1')}>DEBIT</button>
        &nbsp;
        <button type="button" onClick={event => this.props.handlePaymentTypeChange('GIFT CARD')} className={'btn btn-lg ' + (this.props.paymentType === 'GIFT CARD' ? 'btn-success mt-1' : 'btn-primary mt-1')}>GIFT CARD</button>
        <br /><br />
        <button type="button" onClick={event => this.props.handlePaymentTypeChange('VISA')} className={'btn btn-lg ' + (this.props.paymentType === 'VISA' ? 'btn-success mt-1' : 'btn-primary mt-1')}>VISA</button>
        &nbsp;
        <button type="button" onClick={event => this.props.handlePaymentTypeChange('MASTERCARD')} className={'btn btn-lg ' + (this.props.paymentType === 'MASTERCARD' ? 'btn-success mt-1' : 'btn-primary mt-1')}>MASTERCARD</button>
        &nbsp;
        <button type="button" onClick={event => this.props.handlePaymentTypeChange('AMEX')} className={'btn btn-lg ' + (this.props.paymentType === 'AMEX' ? 'btn-success mt-1' : 'btn-primary mt-1')}>AMEX</button>
      </div>
    );
  }
}

export default PaymentTypes;



// WEBPACK FOOTER //
// ./src/containers/payment_types.js